import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const Running = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7801)">
      <rect x="18.7861" y="4" width="4.64286" height="4.64286" rx="2.32143" fill="currentColor" />
      <path d="M21.0002 10.4999L23.0002 12.9999L28.0714 13.2142L28.0002 14.9999H22.0002L20.6428 13.2142L21.0002 10.4999Z" fill="currentColor" />
      <path d="M10.9998 19.0001L13.9998 20.0001L11.9998 25.0001L3.99976 26.0001V24.0001L9.99976 23.0001L10.9998 19.0001Z" fill="currentColor" />
      <path d="M16.4644 7.64282L20.1786 9.96425L19.7144 13.2143L16.9286 17.3928L22.0005 19.9998L25.0005 27.9998H23.0005L20.0005 21.4998L11.0005 17.9998L15.0005 9.99976L10.0005 10.9998L8.5715 15.0714L6.71436 14.1428L8.10721 9.03568L16.4644 7.64282Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7801">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Running'
);
